import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { withIcon } from '../../../core/components/Icon.tsx';
import Layout from '../../../core/components/Layout.tsx';
import Page from '../../../core/components/Page';
import Tooltip from '../../../core/components/Tooltip.tsx';
import AssistantMarketingBanner, { AssistantMarketingKind } from '../components/AssistantMarketingBanner.tsx';
import { OVERVIEW_PATH } from '../constants.ts';

const BackIcon = withIcon(faArrowLeft);

const breadcrumbLinkClassName =
    'flex flex-shrink min-w-0 gap-3 rounded transition-colors hover:bg-surface-strong py-1 px-2 -mx-2 items-center cursor-pointer select-text font-semibold text-base text-content-medium hover:text-content-strong';

const MarketingPage = () => {
    const { t } = useTranslation('assistants');
    const { kind = 'inboxAgent' } = useParams<{ kind: AssistantMarketingKind }>();

    return (
        <Layout>
            <Page>
                <Page.Header>
                    <div className="flex items-center">
                        <Link to={OVERVIEW_PATH} className={`${breadcrumbLinkClassName} text-content-strong mr-1`}>
                            <Tooltip content={t('overview.title')}>
                                <BackIcon />
                            </Tooltip>
                        </Link>
                        <Link to={OVERVIEW_PATH} className={breadcrumbLinkClassName}>
                            {t('overview.title')}
                        </Link>
                        <Page.HeaderSeparator />
                        <Page.HeaderTitle>{t(`overview.locked.${kind}.title`)}</Page.HeaderTitle>
                    </div>
                </Page.Header>

                <Page.Content lowered>
                    <AssistantMarketingBanner
                        kind={kind}
                        tag={t(`overview.marketing.${kind}.tag`)}
                        title={t(`overview.marketing.${kind}.title`)}
                        description={t(`overview.marketing.${kind}.description`)}
                        ctaLabel={t('overview.marketing.cta')}
                    />
                </Page.Content>
            </Page>
        </Layout>
    );
};

export default MarketingPage;
